import generatedData from "./generated/brand-data.json";
import type { BrandData } from "./geometry";

export const brandData = generatedData as BrandData;
export type { BrandData } from "./geometry";
